import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal } from '@/types/proposal';

export function useReviseProposal() {
  const queryClient = useQueryClient();

  return useApiMutation<Proposal, string>({
    mutationFn: (id) => apiPost<Proposal>(operationsClient, opsProposalEndpoints.revise(id)),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.detail(data.id) });
      toast.success(`Revision #${data.revisionNumber} created`);
    },
  });
}
